import PAGE_AND_ROUTES from '../../constants/pagesAndRoutes'

export function getPageFromUrl(url) {
  // Extract the pathname from the URL (ignoring the protocol and domain)
  const urlDetails = new URL(url);
  const pathname = urlDetails?.pathname;
  const subDomain = urlDetails?.host?.split(".")?.[0];

  const subdomainRoutes =
    PAGE_AND_ROUTES?.find((obj) => obj.subDomain == subDomain)?.paths || [];
  const commonRoutes =
    PAGE_AND_ROUTES?.find((obj) => obj.subDomain == "all")?.paths || [];
  const routes = [...subdomainRoutes, ...commonRoutes];

  // Function to check if a path matches a given route
  function matchPath(route, path) {
    const routeParts = route.split("/").filter(Boolean);
    const pathParts = path.split("/").filter(Boolean);

    if (routeParts.length !== pathParts.length) {
      return false;
    }

    for (let i = 0; i < routeParts.length; i++) {
      if (routeParts[i].startsWith(":")) {
        continue;
      } else if (routeParts[i] !== pathParts[i]) {
        return false;
      }
    }
    return true;
  }

  // Iterate over the routes to find a match
  for (const route of routes) {
    if (matchPath(route.path, pathname)) {
      return route;
    }
  }
  return ""; // Default if no match is found
}

// const url = "https://www.careers360.com/exams";
// const page = getPageFromUrl(url);

export default getPageFromUrl
